import ApplicationAdapter from "./application";
import uniqid from "glesys-controlpanel/utils/uniqid";
import { listenerFrom } from "../serializers/load-balancer";

export default class LoadBalancerListenerAdapter extends ApplicationAdapter {
  async createRecord(store, type, snapshot) {
    let loadBalancerId = snapshot.belongsTo("loadBalancer").id;
    let backendname = uniqid("be");
    let frontendname = uniqid("fe");
    let { mode, stickysessions, port, sslcertificate } = snapshot.serialize();

    await this.ajax(`${this.apiBaseUri}/loadbalancer/addbackend?loadbalancerid=${loadBalancerId}`, "POST", {
      data: { name: backendname, mode, stickysession: stickysessions },
    });

    let payload;
    try {
      payload = await this.ajax(
        `${this.apiBaseUri}/loadbalancer/addfrontend?loadbalancerid=${loadBalancerId}&backendname=${backendname}`,
        "POST",
        {
          data: {
            name: frontendname,
            port,
            sslcertificate: sslcertificate === "none" ? undefined : (sslcertificate ?? undefined),
          },
        },
      );
    } catch (error) {
      await this.ajax(
        `${this.apiBaseUri}/loadbalancer/removebackend?loadbalancerid=${loadBalancerId}&backendname=${backendname}`,
        "POST",
      ).catch(() => {});
      throw error;
    }

    return this.listenerFromPayload(payload, frontendname);
  }

  async updateRecord(store, type, snapshot) {
    let loadBalancerId = snapshot.belongsTo("loadBalancer").id;
    let frontendname = snapshot.attr("name");
    let backendname = snapshot.attr("backend");
    let { port, sslcertificate, maxconnections, clienttimeout, mode, stickysessions, connecttimeout, responsetimeout } =
      snapshot.serialize();

    await this.ajax(
      `${this.apiBaseUri}/loadbalancer/editfrontend?loadbalancerid=${loadBalancerId}&frontendname=${frontendname}`,
      "POST",
      { data: { port, sslcertificate: sslcertificate ?? undefined, maxconnections, clienttimeout } },
    );

    let payload = await this.ajax(
      `${this.apiBaseUri}/loadbalancer/editbackend?loadbalancerid=${loadBalancerId}&backendname=${backendname}`,
      "POST",
      { data: { mode, stickysession: stickysessions, connecttimeout, responsetimeout } },
    );

    return this.listenerFromPayload(payload, frontendname);
  }

  async deleteRecord(store, type, snapshot) {
    let loadBalancerId = snapshot.belongsTo("loadBalancer").id;
    let frontendname = snapshot.attr("name");
    let backendname = snapshot.attr("backend");

    await this.ajax(
      `${this.apiBaseUri}/loadbalancer/removefrontend?loadbalancerid=${loadBalancerId}&frontendname=${frontendname}`,
      "POST",
    );
    await this.ajax(
      `${this.apiBaseUri}/loadbalancer/removebackend?loadbalancerid=${loadBalancerId}&backendname=${backendname}`,
      "POST",
    );

    return null;
  }

  listenerFromPayload(payload, frontendname) {
    let { loadbalancer } = payload.response;
    let frontend = loadbalancer.frontends.find((frontend) => frontend.name === frontendname);

    return listenerFrom(loadbalancer, frontend);
  }
}
